import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    amritVarsha: [],
    selectedAmritVarsha: null,
    isLoading: false,
    error: null
};

const amritVarshaSlice = createSlice({
    name: "amritVarsha",
    initialState,
    reducers: {
        setAmritVarsha: (state, action) => {
            state.amritVarsha = action.payload;
        },
        setSelectedAmritVarsha: (state, action) => {
            state.selectedAmritVarsha = action.payload;
        }
    }
});

export const { setAmritVarsha, setSelectedAmritVarsha } = amritVarshaSlice.actions;
export const amritVarshaReducer = amritVarshaSlice.reducer;